var $ = require('jquery');
var debounce = require('debounce');

var Gallery = function Gallery() {
	var $gallery = $('.gallery');

	if($gallery.length) {
		//these are opposite on purpose
		var ops = {
			'-': function(a) { return a + 1; },
			'+': function(a) { return a - 1; }
		}

		var canMove = {
			left: function() { return $.data($gallery[0], 'active') !== 0; },
			right: function() { return $.data($gallery[0], 'active') !== ($gallery.find('.slide').length - 1); }
		}

		var vw = $(window).width();

		//setup slide-wrap to correct length
		var setup = function setup() {
			var wrapWidth = vw * $gallery.find('.slide').length;
			$gallery.find('.slide-wrap').css('width', wrapWidth);	
		};
		setup();

		//handle resize
		$(window).resize(debounce(function() {
			vw = $(this).width();
			setup();
		}, 200));

		//slide gallery
		$.data($gallery[0], 'active', $gallery.find('.slide:first').index());
		$gallery.find('.left, .right').click(function() {
			var dir = '+';
			if($(this).hasClass('right')) dir = '-';

			var canAnimate = true;
			if(dir === '+' && !canMove.left()) canAnimate = false;
			if(dir === '-' && !canMove.right()) canAnimate = false;

			if(canAnimate) {
				//increase/decrease the active counter depending on dir we are moving
				$.data($gallery[0], 'active', ops[dir]($.data($gallery[0], 'active')));

				if(!canMove.left()) { $gallery.find('.left').addClass('hidden'); } else { $gallery.find('.left').removeClass('hidden'); }
				if(!canMove.right()) { $gallery.find('.right').addClass('hidden'); } else { $gallery.find('.right').removeClass('hidden'); }

				$gallery.find('.slide-wrap').clearQueue().animate({
					left: dir + '=' + vw
				}, 300);
			}
		});
	}
}

module.exports = Gallery;